import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Entity } from '@shared/constants/entity';
import { UpsertManyItemStatus } from '@shared/constants/upsert-many';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarConfig } from '@shared/constants/snackbar-config';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DvSnackbarService } from '@devinco/ui/dds/snackbar';
import { SKIP_SUCCESS_INTERCEPTOR } from './http-context-tokens';

@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
  private snackBar = inject(DvSnackbarService);
  private translateService = inject(TranslateService);

  intercept(
    request: HttpRequest<object>,
    next: HttpHandler
  ): Observable<HttpEvent<object>> {
    return next.handle(request).pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tap((response: any) => {
        const skip = request.context.get(SKIP_SUCCESS_INTERCEPTOR);
        if (skip) {
          return;
        }

        if ('url' in response) {
          if (
            (response.url?.includes('/upsert') ||
              response.url?.includes('/put') ||
              response.url?.includes('/update') ||
              response.url?.includes('/SaveExternalApplicationState')) &&
            !response.url.includes('/UserSetting') &&
            !response.url.includes('/upsertMany') &&
            !response.url.includes('/attachment') &&
            !response.url.includes(Entity.UserEventLog) &&
            !response.url.includes(`/upsert/${Entity.FleetLocation}`) &&
            !response.body?.CustomCheck
          ) {
            this.showGeneralSaveSuccessBanner();
          } else if (
            response.url?.includes('/delete') ||
            response.url?.includes('/Delete')
          ) {
            this.snackBar.open(
              this.translateService.instant('General.DeleteActionSuccessful'),
              SnackBarConfig.Success
            );
          } else if (response.url?.includes('/upsertMany')) {
            // for upsertMany statusMessage might be returned sometimes when one or few's record's upsert fails

            const statusMessage: string = response.StatusMessage;

            if (statusMessage) {
              this.snackBar.open(statusMessage, SnackBarConfig.Success);
              return;
            }

            if (Array.isArray(response.body.data)) {
              this.checkforMultiUpsertFailedStatus(response.body.data);
              return;
            }
            this.showGeneralSaveSuccessBanner();
          }
        }
      })
    );
  }

  private showGeneralSaveSuccessBanner(): void {
    this.snackBar.open(
      this.translateService.instant('General.SaveActionSuccessful'),
      SnackBarConfig.Success
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private checkforMultiUpsertFailedStatus(responseData: any[]): void {
    const failedRecords = responseData.filter(
      item => item.Status === UpsertManyItemStatus.Fail
    );

    if (failedRecords.length) {
      this.snackBar.open(
        this.translateService.instant('General.UpsertManySaveWarning'),
        SnackBarConfig.Warning
      );
    } else {
      this.showGeneralSaveSuccessBanner();
    }
  }
}
